var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fff"}},[(_vm.alarmList && _vm.alarmList.length > 0)?_c('div',_vm._l((_vm.alarmList),function(item,index){return _c('single_fault_info',{key:index,staticStyle:{"margin-bottom":"16px"},attrs:{"info":item,"index":index}})}),1):_c('div',[_c('kl-empty')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }